import { Injectable } from '@angular/core';
import { MemberLoyaltyStatusService } from './member-loyalty-status.service';
import { LoggingService } from '../../shared/services/core/logging.service';

@Injectable({ providedIn: 'root' })
export class MemberLoyaltyStatusResolver {
  constructor(private memberLoyaltyStatusService: MemberLoyaltyStatusService, private loggingService: LoggingService) {}

  resolve() {
    this.loggingService.info('resolving member loyalty status info');
    return this.memberLoyaltyStatusService.fetchMemberLoyaltyStatus();
  }
}
